import { gql } from 'apollo-boost'

export const PAGE_INFO_FRAGMENT = gql`
  fragment PageInfo on PageInfo {
    offset
    total
  }
`
